<template>
  <el-dialog class="wx-dialog" :title="title" :visible.sync="options.show" close="cancel" :width="options.width">
    <div class="search-title">
      <div class="select-info">
        <span>选择同步的公众号：</span>
        <el-select v-model="keyWord" clearable placeholder="请选择">
          <el-option
            v-for="item in optionsList"
            :key="item.value"
            :label="item.label"
            :value="item.value">
          </el-option>
        </el-select>
      </div>
      <el-button type="text">添加公众号</el-button>
    </div>
    <div class="sync-list">
      <div class="left-info">
        <div class="fix-content">
          <div class="alside-left">
            <ul>
              <li v-for="(item,index) in lists" :key="index" >
                <div class="home-img" v-if="index===0">
                  <img :src="item.img" />
                  <p class="home-title">{{item.title}}</p>
                </div>
                <div class="sync-img" v-else>
                  <div class="left-icoon">
                    <p class="sync-title">{{item.title}}</p>
                    <p class="sync-date">{{item.createdat}}</p>
                  </div>
                  <img :src="item.img" width="80" height="80" />
                </div>
                <div class="opreate-btn">
                  <el-button  type="success" icon="el-icon-arrow-right" circle @click="appUserAddHandle(item)" title="添加"></el-button>
                </div>
              </li>
            </ul>
            <div v-infinite-scroll="hideScroll" :infinite-scroll-disabled="busy" :infinite-scroll-distance="10"></div>
          </div>
        </div>
      </div>
      <div class="icon-left">
         <el-button type="info" circle class="el-icon-arrow-right"></el-button>
      </div>
      <div class="alside-right" >
        <ul v-if="selectedUserList && selectedUserList.length >0">
          <li v-for="(item, $index) in selectedUserList" :key="item">
            <div class="home-img" v-if="$index===0">
              <img :src="item.img" />
              <p class="home-title">{{item.title}}</p>
            </div>
            <div class="info-ul" v-else>
              <div class="sync-img" >
                <div class="left-icoon">
                  <p class="sync-title">{{item.title}}</p>
                </div>
                <img :src="item.img" width="80" height="80" />
              </div>
            </div>
            <div class="opreate-btn">
              <el-button v-if="$index!==0" @click="upSort($index)" type="info" class="up-btn" size="mini" icon="el-icon-arrow-up" circle></el-button>
              <el-button size="small"  class="del-handel" type="text" @click="appUserDelHandle(item)" title="删除"><i class="el-icon-delete"></i></el-button>
              <el-button type="info" v-if="$index!== selectedUserList.length -1"  @click="upDown($index)" class="up-btn"  size="mini" icon="el-icon-arrow-down" circle></el-button>
            </div>
          </li>
        </ul>
        <div class="right-warn" v-else>
          <p>点击左侧添加待同步的图文</p>
          <p>选择一篇文章，同步到微信公众号为单图文；</p>
          <p>选择多篇文章，同步到微信公众号为多图文</p>
        </div>
      </div>
    </div>
    <!-- <div>
      <p v-for="(item,index) in data">
        {{item}}
        <el-button @click="up(index)">上移</el-button>
        <el-button @click="down(index)">下移</el-button>
      </p>
    </div> -->
    <div slot="footer" class="footer-dialog-article" style="text-align:center;margin-top:10px">
      <el-button type="success" @click="submit('uiEduction')">确 定</el-button>
      <el-button type="success" @click="cancel">取 消</el-button>
    </div>
  </el-dialog>
</template>

<script>
import ArticleService from '@/service/api/articleService'
import _ from 'lodash'

export default {
  props: {
    metaData: {
      type: Object,
      default: {}
    },
    cancelFn: {
      type: Function,
      default: () => undefined
    },
    submitFn: {
      type: Function,
      default: () => undefined
    },
    options: {
      type: Object,
      default: {}
    },
    title: {
      type: String,
      default: ''
    }
  },

  data () {
    return {
      departmentId: '',
      departmentIdList: [],
      optionsList: [],
      itemSet_split: [],
      busy: false,
      searchVal: {
        tag: null,
        page: 1,
        type: 1
      },
      keyWord: null,
      lists: [],
      selectedUserList: [],
      addAppUserDisable: false,
      data: ['ui1', 'ui2','ui3','ui4','ui5','ui6']
    }
  },

  created () {
    this.getList()
  },

  methods: {
    getList (flag) {
      const articleSystem = new ArticleService()
      articleSystem.articleList(this.searchVal)
        .then(({ data }) => {
          if(flag){
            // 多次加载数据
            this.lists = [
              ...this.lists,
              ...data.data
            ]
            if(data.data.length === 0){
              this.busy = true;
            }else{
              this.busy = false;
            }
          }else{
            // 第一次加载数据
            this.lists = data.data;
            // 当第一次加载数据完之后，把这个滚动到底部的函数触发打开
            this.busy = false;
          }
        }, (error) => {
          this.$notify.error(error.message)
      })
    },
    hideScroll () {
      this.busy = true;
      // 多次加载数据
      setTimeout(() => {
        if (this.searchVal.page > this.total) {
          return
        } else {
          this.searchVal.page ++;
          this.getList(true);
        }
      }, 1000);
    },
    appUserAddHandle (user) {
      this.selectedUserList.push(user)
      this.selectedUserList = _.unionBy(this.selectedUserList, 'id')
      _.remove(this.lists, (val) => {
        return val.id === user.id
      })
    },
    alterItem(arr, index1, index2) {
      arr[index1] = arr.splice(index2, 1, arr[index1])[0];
      return arr;
    },
    upSort(index) {
      this.alterItem(this.selectedUserList, index, index-1)
      console.log(this.selectedUserList, 'zh')
    },
    upDown(index) {
      this.alterItem(this.selectedUserList, index, index + 1);
      console.log(this.selectedUserList, 'oo')
    },
    // up(index) {
    //   this.alterItem(this.data, index, index-1)
    //   console.log(this.data, 'zh')
    // },
    // down(index) {
    //   this.alterItem(this.data, index, index + 1);
    //   console.log(this.data, 'oo')
    // },
    appUserDelHandle(items) {
      this.lists.push(items)
      this.lists = _.unionBy(this.lists, 'id')
      _.remove(this.selectedUserList, (val) => {
        return val.id === items.id
      })
      // this.selectedUserList.splice(index, 1)
    },
    submit () {
      const companyAppService = new companyAppInfo.CompanyAppSystem()
      const ids = []
      _.each(this.selectedUserList, (val, index) => {
        ids.push(val.companyUserId)
      })
      const params = {
        companyAppId: this.metaData.obj.companyAppId,
        companyUserIds: _.join(ids, ',')
      }
      if (this.metaData.obj && (this.metaData.obj.name ==='first'|| this.metaData.obj.name ==='second')) {
        companyAppService.userOpenApp(params).then(() => {
        if (this.submitFn && typeof this.submitFn === 'function') {
          this.submitFn()
        }
        this.$destroy()
        }, (error) => {
          this.$message.error(error.message)
        })
      } else {
        companyAppService.forbideUser(params).then(() => {
        if (this.submitFn && typeof this.submitFn === 'function') {
          this.submitFn()
        }
        this.$destroy()
        }, (error) => {
          this.$message.error(error.message)
        })
      }
      
    },

    cancel () {
      if (this.cancelFn && typeof this.cancelFn === 'function') {
        this.cancelFn()
      }
      this.$destroy()
    }
  },

  destroyed () {
    document
      .getElementById('app')
      .removeChild(this.$el)
  }
}

</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
  .search-title{
    display: flex;
    font-size: 13px;
    margin: 10px 0
  }
  .sync-list{
    display: flex;
    align-items: flex-start;
    .left-info{
      width: 42%;
      .fix-content{
        background: #eee;
        border-radius: 2px;
        min-height: 500px;
        .alside-left{
          padding: 10px;
          ul{
            height: 580px;
            overflow-y: auto;
            overflow-x: hidden;
            li{
              background: #fff;
              border: dashed 1px #ccc;
              padding: 10px;
              margin-top: 10px;
              position: relative;
              &:first-child{
                margin-top: 0;
                background: none;
                border: none;
                padding: 0;
                height: 144px;
              }
              &:hover{
                .opreate-btn{
                  display: flex;
                  padding: 0;
                }
              }
              .opreate-btn{
                position: absolute;
                left: 0;
                z-index: 1000;
                border: solid;
                width: 100%;
                height: 100%;
                display: none;
                justify-content: center;
                align-items: center;
                top: 0;
                background: rgba(103, 194, 58, 0.4);
                border: solid 1px #67c23a;
              }
            }
          }
        }
      }
    }
    .alside-right{
      background: #eee;
      border-radius: 2px;
      flex: 1;
      height: 100%;
      margin-left: 100px;
      .right-warn{
        font-size: 12px;
        color: #929292;
        min-height: 100px;
        padding:200px 0;
        text-align: center;
        display: flex;
        flex-wrap: wrap;
        p{
          width: 100%;
        }
      }
      ul{
        padding: 10px;
        height: 580px;
        overflow-y: auto;
        overflow-x: hidden;
        .info-ul{
          width: 100%;
          background: #fff;
          padding: 10px;
          .sync-img{
            align-items: center;
          }
        }
        li{
          display: flex;
          justify-content: space-around;
          align-items: center;
          position: relative;
          &:first-child{
            margin-top: 0;
            background: none;
            border: none;
            padding: 0;
            height: 144px;
          }
          .item-right{
            border-bottom: solid 1px #ccc;
            background: #fff;
            padding: 10px;
            width: 80%;
          }
          .opreate-btn{
            width: 30px;
            .up-btn{
              padding: 2px !important;
              margin-left: 10px !important;
              &:hover{
                background: #ff6600 !important;
                color: #fff;
                border-color: #ff6600;
              }
            }
          }
          .del-handel{
            color: #929292;
            font-size: 18px;
            cursor: pointer;
            margin: 10px 8px;
            &:hover{
              color: #ff6600;
            }
          }
        }
      }
    }
    .icon-left{
      position: absolute;
      left: 50%;
      margin-left: -5%;
      top: 50%;
    }
    .home-img{
      width: 100%;
      img{
        width: 100%;
        height: 145px;
      }
      .home-title{
        position: absolute;
        bottom: 20px;
        width: 85%;
        color: white;
        padding: 0 10px;
        overflow: hidden;
        white-space: nowrap;
        text-overflow:ellipsis;
      }
    }
    .sync-img{
      display: flex;
      justify-content: space-between;
      align-items: flex-start;
      font-size: 14px;
      .sync-title{
        color: #535353;
        font-size: 14px;
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 2;
      }
      .sync-date{
        font-size: 12px;
        color: #999;
        position: absolute;
        bottom: 10px;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/dialog/syncArticle.vue